import { render, staticRenderFns } from "./WariWariHero.vue?vue&type=template&id=1cf5d57c&"
import script from "./WariWariHero.vue?vue&type=script&lang=js&"
export * from "./WariWariHero.vue?vue&type=script&lang=js&"
import style0 from "./WariWariHero.vue?vue&type=style&index=0&id=1cf5d57c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports